import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/workflow/levels";
import levels from "../../models/workflow/levels";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    levels: [],
    edit: [],
    new: [],
    deleteItem: [],
  },

  mutations: {
    setLevels(state, data) {
      state.levels = data;
    },

    setEdit(state, data) {
      state.edit = data;
    },
    setNew(state, data) {
      state.new = data;
    },
    setDeleteItem(state, data) {
      state.deleteItem = data
    },
   
  
  },
  actions: {
    async getLevels(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getLevels();

          state.commit("setLevels",  item );
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },


      async edit(state) {
        return new Promise(async (resolve, reject) => {
          try {
            await state.state.service.edit(state.state.edit).then(() => {
              let item = state.state.edit
              let options = state.state.levels
              options = options.map((option)=>{
              if(option.id != item.id){
                return option
              }
              item = levels.fromJson({
                nivelId:item.id,
                nombre:item.name,
                valor:item.value
              })
              return item
              })
              state.commit('setLevels', options)
              resolve(true)
            })
          }
          catch (error) {
            reject(error)
          }
        })

      },
      async new(state) {
        return new Promise(async (resolve, reject) => {
          try {
            await state.state.service.new(state.state.new).then((data) => {
              let item = state.state.new
              let options = state.state.levels
              let newItem = levels.fromJson({
                nivelId:data.data.nivelId,
                nombre:item.name,
                valor:item.value
              })
              options.push(newItem);
              state.commit('setLevels', options)
              resolve(true)
            })
          }
          catch (error) {
            reject(error)
          }
        })

    },
    async delete(state) {
      return new Promise(async (resolve, reject) => {
        try {
       await state.state.service.delete(state.state.deleteItem).then(() => {
        let options = state.state.levels
        
        options = options.filter(option => {
          return option.id != state.state.deleteItem
        })

            state.commit('setLevels', options)
            resolve(true)
          });
        } catch (error) {
          reject(error)
  
        }
      })
     
    },
  },
});
